module.exports = __webpack_public_path__ + "img/Elektronik,-IT-udstyr-og-Batterier.5634eb19.jpg";